import { useState } from "react"
import { Button, Menu, MenuItem } from "@material-ui/core"
import { ImgWrapper, ZoomPopupWrapper } from "./styles"

const ZoomPopup = ({ src, alt, isVisible }) => {
  return (
    <ZoomPopupWrapper isVisible={isVisible}>
      <img src={src} alt={alt} />
    </ZoomPopupWrapper>
  )
}

const ImageWithZoom = (props) => {
  const {
    src = "/static/img/noproducts.png",
    alt = "sample",
    isEnableZoom = true,
  } = props || {}
  const [isHovered, setIsHovered] = useState(false)

  return (
    <>
      {isEnableZoom ? (
        <>
          <ImgWrapper
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img src={src} alt={alt} />
          </ImgWrapper>
        </>
      ) : (
        <>
          <ImgWrapper>
            <img src={src} alt={alt} />
          </ImgWrapper>
        </>
      )}
      {isEnableZoom && <ZoomPopup src={src} alt={alt} isVisible={isHovered} />}
    </>
  )
}

export default ImageWithZoom
export { ImageWithZoom }
